import React, { Fragment, useContext, useEffect, useState, useMemo, useCallback } from 'react';
import { TableSectionV2 } from 'components/UI';
import localization from 'assets/localization/localization';
import { BaseUrl } from '../../../../contexts/baseUrl/baseUrl';
import Layout from '../../../sales/layout/layout';
import moment from 'moment';
import ListFilters from '../../../sales/ListFilters/ListFilters';
import { Button } from 'react-bootstrap';
import Images from '../../../../assets/images/imageData';

const cell = (val) => (val != null && val !== '' ? String(val) : '—');

const HierarchyListing = ({
  financeHierarchyListing,
  helpdeskHierarchyListing = [],
  userRequestFilter,
  filterDetails = [],
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const { baseUrl } = useContext(BaseUrl);
  const [listData, setListData] = useState([]);
  const [showFilter, setShowFilter] = useState(false);
  const [filterData, setFilterData] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const getFilter = JSON.parse(localStorage.getItem('help_desk_finance_pending'));
      const storedPage = localStorage.getItem('page');

      let page;
      if (storedPage !== undefined && storedPage !== '' && storedPage !== null) {
        page = storedPage;
      } else {
        page = 1;
      }

      try {
        if (getFilter !== null && Object.keys(getFilter).length > 0) {
          await financeHierarchyListing(page, getFilter);
        } else {
          await financeHierarchyListing(page, null);
        }

        await userRequestFilter();
      } finally {
        setIsLoading(false);
      }
    })();
  }, []);

  useEffect(() => {
    if (filterDetails?.status !== undefined) {
      delete filterDetails?.status;
    }
  }, [filterDetails]);

  const buildRowActions = useCallback(
    (row) => [
      {
        name: 'View',
        link: `${baseUrl}/request-view/${row.id}`,
      },
    ],
    [baseUrl]
  );

  const tableColumns = useMemo(
    () => [
      { key: 'request_id', label: 'Request Id', format: (val) => cell(val) },
      { key: 'request_name', label: 'Requester Name', format: (val) => cell(val) },
      {
        key: 'requested_date',
        label: 'Requested Date',
        format: (val) => {
          if (!val) return '—';
          const formatted = moment(val).format('DD-MMMM-YYYY');
          return formatted === 'Invalid date' ? '—' : formatted;
        },
      },
      { key: 'use_case_name', label: 'Finance use case', format: (val) => cell(val) },
      { key: 'a1_approval_name', label: 'Approver L1', format: (val) => cell(val) },
      { key: 'a2_approval_name', label: 'Approver L2', format: (val) => cell(val) },
      { key: 'PI_no', label: 'PI', format: (val) => cell(val) },
      { key: 'TI_no', label: 'TI', format: (val) => cell(val) },
      { key: 'status', label: 'Request Status', format: (val) => cell(val) },
      { key: 'finance_approval_name', label: 'Finance acted by', format: (val) => cell(val) },
      {
        key: 'actions',
        label: 'Actions',
        getActions: (row) => buildRowActions(row),
      },
    ],
    [buildRowActions]
  );

  const onPageChange = async (val) => {
    setIsLoading(true);
    localStorage.setItem('page', val.selected + 1);
    await financeHierarchyListing(val.selected + 1, filterData);
    setIsLoading(false);
  };

  useEffect(() => {
    if (
      helpdeskHierarchyListing &&
      helpdeskHierarchyListing !== [] &&
      helpdeskHierarchyListing.data !== undefined &&
      helpdeskHierarchyListing.data.length > 0
    ) {
      setListData(helpdeskHierarchyListing.data);
      setPageCount(Math.ceil(helpdeskHierarchyListing.total / helpdeskHierarchyListing.per_page));
      setCurrentPage(helpdeskHierarchyListing.current_page);
    } else if (helpdeskHierarchyListing?.data !== undefined) {
      setListData([]);
      setPageCount(0);
    }
  }, [helpdeskHierarchyListing]);

  const filterToggle = () => {
    setShowFilter(!showFilter);
  };

  const applyFilter = async (appliedFilterData) => {
    localStorage.setItem('help_desk_finance_pending', JSON.stringify(appliedFilterData));
    setIsLoading(true);
    setFilterData(appliedFilterData);
    setListData([]);
    await financeHierarchyListing(1, appliedFilterData);
    setIsLoading(false);
    filterToggle();
  };

  const srNo =
    helpdeskHierarchyListing?.from ??
    (helpdeskHierarchyListing?.current_page && helpdeskHierarchyListing?.per_page
      ? (helpdeskHierarchyListing.current_page - 1) * helpdeskHierarchyListing.per_page + 1
      : 1);

  const headerBtns = () => {
    return (
      <Fragment>
        <Button onClick={filterToggle} className="filter-hamburger show-btn btn btn-transparent">
          {' '}
          <img src={Images?.Filter} alt="" />
          {localization.showFilters}
        </Button>
      </Fragment>
    );
  };

  return (
    <Layout title={localization.hierarchyList} isLoading={isLoading} useNewHeaderLayout Buttons={headerBtns}>
      <TableSectionV2
        hideHeader
        hideTitleAndStatusFilter
        className="site-dashboard-table-section"
        tableData={listData}
        tableColumns={tableColumns}
        tableSectionProps={{ srNo }}
        pageCount={pageCount}
        currentPage={currentPage}
        onPageChange={onPageChange}
        isLoading={isLoading}
        emptyMessage="No requests found."
      />
      <ListFilters
        showFilter={showFilter}
        filterToggle={filterToggle}
        applyFilter={(val) => applyFilter(val)}
        listFilterData={filterDetails}
        helpdeskFilter={true}
        localstorageKey={'help_desk_finance_pending'}
      />
    </Layout>
  );
};

export default HierarchyListing;
